'use client';

import dynamic from 'next/dynamic';
import type { FC, JSX } from 'react';
import type { ApiProduct } from '../../../api/model';
import IsScrolledWrapper from '@/components/lazyWrapper/IsScrolledWrapper';

const BVDetailedReviews = dynamic(() => import('@/components/bazaarVoice/BVDetailedReviews'), {
  ssr: false
});

const BVDetailedReviewsClientImporter: FC<{
  bazaarVoiceId: string;
  locale: string;
  product?: Partial<ApiProduct>;
  bvSrc?: string;
  currentUrl?: string;
}> = (props): JSX.Element => {
  return (
    <IsScrolledWrapper>
      <BVDetailedReviews {...props} />
    </IsScrolledWrapper>
  );
};

export default BVDetailedReviewsClientImporter;
